module.exports = __webpack_public_path__ + "static/media/flickr.a22f472e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/components/Footer/img/flickr.svg
// module id = 146
// module chunks = 0